import type { ReactNode } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEntitlements } from "../hooks/useEntitlement";

/**
 * Guardia de ruta por derecho (épica #662, #649).
 *
 * Si el backend dice que la sesión no tiene `entitlement`, redirige al Apps Hub
 * con el motivo, para que la pantalla explique por qué ("no está en tu plan",
 * "apagado para todos"…) en vez de abrir algo que no corresponde.
 *
 * Mientras no haya respuesta del backend, deja pasar: una API caída no debe
 * dejar a nadie fuera, y la API protege lo suyo por separado.
 *
 * Como ruta layout usa `<Outlet />`; para proteger una ruta índice, se le pasa
 * el contenido como `children`.
 */
export default function EntitlementRoute({
  entitlement,
  redirectTo = "/apps",
  children,
}: {
  entitlement: string;
  redirectTo?: string;
  children?: ReactNode;
}) {
  const { can, reasonFor } = useEntitlements();
  const location = useLocation();

  if (!can(entitlement)) {
    return (
      <Navigate
        to={redirectTo}
        replace
        state={{
          deniedPath: location.pathname,
          reason: reasonFor(entitlement),
          entitlement,
        }}
      />
    );
  }

  return children ? <>{children}</> : <Outlet />;
}
